import { memo } from "react"

const Help = () => {
    return (
        <div className="m-container">
            راهنما و آموزش
        </div>
    )
}

export default memo(Help);